var _circle, _rect, _rect2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPendingIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 14,
    viewBox: "0 0 11 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 5.5,
    cy: 8.5,
    r: 5.12,
    stroke: "#193243",
    strokeWidth: 0.76
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 4.71484,
    y: 4.57031,
    width: 1.57143,
    height: 6.28571,
    rx: 0.785714,
    fill: "#183242"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 2.35742,
    y: 2.21484,
    width: 1.57143,
    height: 6.28571,
    rx: 0.785714,
    transform: "rotate(-90 2.35742 2.21484)",
    fill: "#183242"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPendingIcon);
export default __webpack_public_path__ + "static/media/pending_icon.97a809980700245204542c70940258b5.svg";
export { ForwardRef as ReactComponent };